var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (this.show)?_c('div',{staticClass:"announcement-banner",attrs:{"title":"Dismiss this message."},domProps:{"innerHTML":_vm._s(_vm.msg)},on:{"click":function($event){return _vm.dismiss()}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }